/** @type {import('$lib/types').MenuDataSource} */
export const menuDataSource = {
	items: [
		{
			name: 'Tableau de bord',
			path: '/',
			allowedRoles: ['admin', 'gestionnaire', 'comptable']
		},
		// AUTH
		{
			name: 'Connexion',
			path: '/auth/login',
			allowedRoles: ['public']
		},
		{
			name: 'Mot de passe oublié',
			path: '/auth/forgot-password',
			allowedRoles: ['public']
		},
		{
			name: 'Récupération de mot de passe',
			path: '/auth/password-reset',
			allowedRoles: ['public']
		},
		{
			name: 'Nouveau mot de passe',
			path: '/auth/new-password',
			allowedRoles: ['public']
		},
		// ADMIN
		{
			name: 'Administration',
			items: [
				{
					name: 'Gestion des utilisateurs',
					path: '/admin/users',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin']
				}
			]
		},
		{
			name: 'Contrats et PECs',
			items: [
				{
					name: 'Contrats',
					path: '/contrats/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire']
				},
				{
					name: 'PECs',
					path: '/pecs/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire']
				},
			]
		},
		{
			name: 'Factures OPCO',
			items: [
				{
					name: 'Echéances à facturer',
					path: '/echances-a-facturer/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire', 'comptable']
				},
				{
					name: 'Liste des factures OPCO',
					path: '/factures/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire', 'comptable']
				},
			]
		},
		{
			name: 'Factures entreprise',
			items: [
				{
					name: 'Factures à émettre',
					path: '/factures-entreprise/a-emettre',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire', 'comptable']
				},
			{
				name: 'Nouvelle facture entreprise',
				path: '/factures-entreprise/nouvelle',
				// iconName: 'mdi:account-group',
				allowedRoles: ['admin', 'gestionnaire', 'comptable']
			},
			{
				name: 'Liste des factures entreprise',
				path: '/factures-entreprise/liste',
				// iconName: 'mdi:account-group',
				allowedRoles: ['admin', 'gestionnaire', 'comptable']
			},
			]
		},
		{
			name: 'OPCO',
			items: [
				{
					name: 'OPCOs',
					path: '/opcos/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire']
				},
				{
					name: 'Contact OPCO',
					path: '/opcos/contacts',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire']
				},
			]
		},
		{
			name: 'Paiement',
			items: [
				{
					name: 'Paiements',
					path: '/paiements/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire', 'comptable']
				},
				{
					name: 'Comptes Bancaires',
					path: '/comptes-bancaires/liste',
					// iconName: 'mdi:account-group',
					allowedRoles: ['admin', 'gestionnaire']
				}
			]
		},
	]
};
